import { Box, Grid, TextField } from "@mui/material";
import SamplePromptBox from "./SamplePromptBox";
import "../styles/commonStyles.css"

const sampleData = [
    {
      prompt: 'Classify messages into bugs from Slack, enter bugs into Airtable, assign bugs to the right team, and notify the team via Slack',
      logos: ['https://www.google.com/s2/favicons?domain=slack.com&sz=32', 'https://www.google.com/s2/favicons?domain=nanonets.com&sz=32', 'https://www.google.com/s2/favicons?domain=airtable.com&sz=32']
    },
    {
      prompt: 'Send my bank statements from my email to Google Drive. When my accountant sends me an email asking for statements, match the date of the statements he asked for with the statements in my drive and email them to him',
      logos: ['https://upload.wikimedia.org/wikipedia/commons/7/7e/Gmail_icon_%282020%29.svg', 'https://www.google.com/s2/favicons?domain=google.com&sz=28', 'https://upload.wikimedia.org/wikipedia/commons/7/7e/Gmail_icon_%282020%29.svg']
    },
    {
      prompt: 'Before 15 minutes of calls on Google Calendar, be notified on Microsoft Teams of people who have not accepted the invite',
      logos: ['https://www.google.com/s2/favicons?domain=google.com&sz=28', 'http://www.google.com/s2/favicons?domain=www.ifttt.com&sz=32', 'http://www.google.com/s2/favicons?domain=www.microsoft.com&sz=32']
    },
    {
      prompt: 'Every week, get a list of all my investments on our website, go to each of their websites, check their domain ranking and traffic from Ahrefs and SEMrush, and send me a summary of all the news, their domain ranking, and traffic from Ahrefs and SEMrush',
      logos: ['http://www.google.com/s2/favicons?domain=www.ahrefs.com&sz=32', 'http://www.google.com/s2/favicons?domain=www.semrush.com&sz=32', 'https://upload.wikimedia.org/wikipedia/commons/7/7e/Gmail_icon_%282020%29.svg']
    },
    {
      prompt: 'Respond to all the recruiters on LinkedIn who have messaged me in the last 2 days with my resume and a message saying I am interested in the job and times when I am available for a call from my calendar',
      logos: ['http://www.google.com/s2/favicons?domain=www.linkedin.com&sz=32', 'https://www.google.com/s2/favicons?domain=google.com&sz=28', 'http://www.google.com/s2/favicons?domain=www.linkedin.com&sz=32']
    },
    {
      prompt: 'Review all the sales calls I did this week and send a summary of all the calls to my manager with the following details: call duration, call date, call time, call notes, call recording, call transcript, call score, call tags, and call sentiment',
      logos: ['http://www.google.com/s2/favicons?domain=www.salesforce.com&sz=32', 'https://www.google.com/s2/favicons?domain=google.com&sz=28']
    },
    {
      prompt: 'Weekly crawl our competitor websites, check for any new logos. If a new logo is found, find details of the customer and the best person to reach out to on LinkedIn, get their email, create a draft email to them, and add it to my outreach inbox',
      logos: ['http://www.google.com/s2/favicons?domain=www.crawler.com&sz=32', 'http://www.google.com/s2/favicons?domain=www.image-recognition.com&sz=32', 'http://www.google.com/s2/favicons?domain=www.linkedin.com&sz=32', 'https://upload.wikimedia.org/wikipedia/commons/7/7e/Gmail_icon_%282020%29.svg']
    },
    {
      prompt: 'When there is a new bug in Airtable, categorize it based on name. In Airtable, assign it to a person based on the category',
      logos: ['http://www.google.com/s2/favicons?domain=www.airtable.com&sz=32', 'http://www.google.com/s2/favicons?domain=www.nanonets.com&sz=32', 'http://www.google.com/s2/favicons?domain=www.airtable.com&sz=32']
    }
];

type SamplePromptProps = {
  currentInput: string;
  setCurrentInput: React.Dispatch<React.SetStateAction<string>>;
  setUserInput: React.Dispatch<React.SetStateAction<string[]>>;
  fetchAPI: (query: string) => void;
}

const SamplePrompt: React.FC<SamplePromptProps> = ({
  currentInput,
  setCurrentInput,
  setUserInput,
  fetchAPI,
}) => {
    const initiateWorkflow = (prompt: string) => {
      setUserInput([prompt]);
      fetchAPI(prompt);
    }

    return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", flexDirection: "column", flex: 1 }}>
      <Box sx={{ marginTop: "40px", maxWidth: "800px", width: "100%" }}>
        <TextField
          placeholder='What do you want to automate today?'
          variant='outlined'
          fullWidth
          value={currentInput}
          onChange={(e) => {
            setCurrentInput(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              initiateWorkflow(currentInput)
            }
          }}
          InputProps={{ disableUnderline: true }}
          inputProps={{
            style: { fontSize: 12 }
          }}
          sx={{
            background: "#fff", color: "#7E86A0", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.08)"
          }}
        />
      </Box>
      <Box sx={{ maxWidth: "800px", height: "calc(100% - 130px)", marginTop: "40px" }}>
        <Box sx={{ fontSize: 16, fontWeight: 600, textAlign: "center", marginBottom: 2 }}>What others are Automating</Box>
        <Box sx={{ height: "calc(100% - 56px)", overflow: "auto", paddingBottom: "20px" }} className="noScrollbar">
          <Grid container spacing={2} alignItems="stretch">
              {sampleData.map((sample, index) => {
                  return <Grid item xs={4} key={index}>
                      <SamplePromptBox sample={sample} initiateWorkflow={initiateWorkflow} />
                  </Grid>
              })}
          </Grid>
        </Box>
      </Box>
    </Box>
}

export default SamplePrompt;